import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, X, Send } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import api from "../lib/api";

export default function ChatWidget() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const endRef = useRef(null);

  const canChat = user && user.role === "customer";

  const load = async () => {
    if (!canChat) return;
    try {
      const { data } = await api.get("/chat/thread");
      setMsgs(data);
    } catch {}
  };

  useEffect(() => {
    if (open && canChat) {
      load();
      const t = setInterval(load, 4000);
      return () => clearInterval(t);
    }
  }, [open, canChat]);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs]);

  const send = async () => {
    if (!text.trim()) return;
    const t = text.trim();
    setText("");
    try {
      await api.post("/chat/message", { text: t });
      load();
    } catch {}
  };

  return (
    <>
      <button
        onClick={() => setOpen(!open)}
        className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full btn-gold flex items-center justify-center shadow-2xl"
        data-testid="chat-widget-toggle"
        aria-label="Canlı Sohbet"
      >
        {open ? <X size={24} /> : <MessageCircle size={24} />}
      </button>

      {open && (
        <div className="fixed bottom-24 right-6 z-50 w-[92vw] max-w-sm card-lux overflow-hidden slide-in-right flex flex-col" style={{ height: 460 }} data-testid="chat-widget-panel">
          <div className="px-5 py-4 border-b border-[#D4AF37]/20 flex items-center gap-3">
            <img src="/cafein-icon.png" alt="CAFE-İN" className="h-9 w-9 object-contain" />
            <div>
              <div className="font-serif text-lg gold-text leading-none">CAFE-İN Destek</div>
              <div className="text-[11px] text-emerald-400 font-mono mt-1">● Çevrimiçi</div>
            </div>
          </div>

          {!canChat ? (
            <div className="flex-1 flex flex-col items-center justify-center gap-4 p-6 text-center">
              <MessageCircle className="text-[#D4AF37]" size={40} />
              <p className="text-zinc-300 text-sm">Canlı sohbet için müşteri hesabınızla giriş yapın. Bize her konuda yazabilirsiniz!</p>
              <Link to="/giris" className="btn-gold px-6 py-2.5 rounded-xl text-sm" data-testid="chat-login-btn">Giriş Yap</Link>
            </div>
          ) : (
            <>
              <div className="flex-1 overflow-y-auto p-4 space-y-3 no-scrollbar">
                {msgs.length === 0 && <p className="text-center text-zinc-500 text-sm mt-8">Merhaba! Size nasıl yardımcı olabiliriz?</p>}
                {msgs.map((m) => (
                  <div key={m.id} className={`flex ${m.fromRole === "owner" ? "justify-start" : "justify-end"}`}>
                    <div className={`max-w-[80%] px-4 py-2.5 rounded-2xl text-sm ${m.fromRole === "owner" ? "bg-[#1E1E24] text-zinc-200 border border-[#D4AF37]/20" : "btn-gold rounded-br-sm"}`}>
                      {m.text}
                    </div>
                  </div>
                ))}
                <div ref={endRef} />
              </div>
              <div className="p-3 border-t border-[#D4AF37]/20 flex items-center gap-2">
                <input
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && send()}
                  placeholder="Mesajınızı yazın..."
                  className="lux-input flex-1 py-2.5"
                  data-testid="chat-input"
                />
                <button onClick={send} className="btn-gold h-11 w-11 rounded-xl flex items-center justify-center shrink-0" data-testid="chat-send-btn">
                  <Send size={18} />
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
}
